import { ChartClient } from '@frontend/chart/api';
import { EquipmentStateAllDonutChart } from '@frontend/chart/components';
import { Chart } from '@frontend/chart/types';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { getLendingEquipmentStateNavigateTarget } from '../get-lending-equipment-state-navigate-target';
import { LendingEquipmentStateDonutChartProps } from './lending-equipment-state-donut-chart.component';

export const useLendingEquipmentStateDonutChart = (props: LendingEquipmentStateDonutChartProps) => {
    const navigate = useNavigate();
    const [data, setData] = useState<Chart | undefined>(undefined);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!props.accountId) {
            setIsLoading(false);
            return;
        }

        let cancelled = false;
        setIsLoading(true);

        ChartClient.fetchChartData(props.accountId, EquipmentStateAllDonutChart.definition)
            .then((chart) => {
                if (!cancelled) {
                    setData(chart);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setData(undefined);
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setIsLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [props.accountId]);

    return { data, isLoading, getNavigateTarget: getLendingEquipmentStateNavigateTarget, navigate };
};
